module.exports = __webpack_public_path__ + "../resources/img/ic_hail_weather.29b8ec6d.svg";